export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'star', name: '明星八卦', slug: 'star' },
  { id: 'internet-celebrity', name: '网红爆料', slug: 'internet-celebrity' },
  { id: 'variety', name: '综艺热瓜', slug: 'variety' },
  { id: 'expose', name: '黑料实锤', slug: 'expose' },
  { id: 'drama', name: '影视吃瓜', slug: 'drama' },
  { id: 'trending', name: '今日热搜', slug: 'trending' },
];

export const articles = [
  {
    id: 1,
    title: '某顶流明星被曝深夜密会神秘女子，工作室紧急发文回应',
    category: 'star',
    excerpt: '近日有狗仔拍到某顶流男星深夜与一名神秘女子同回公寓，引发网友热议。该明星工作室凌晨紧急发布声明，称二人仅为普通朋友关系，望大家不要过度解读。',
    content: '<p>近日，知名娱乐博主「娱乐圈侦探」发布了一组照片，照片中显示某顶流男星深夜与一名神秘女子一同返回位于北京某高档小区的公寓。</p><p>据爆料人称，当晚该男星结束工作后，并未返回自己住所，而是直接前往该女子所在小区，二人在车库碰面后一同进入电梯。直到次日凌晨三点，该男星才独自离开。</p><p>消息一出，立即在社交平台引发轩然大波。不少网友开始扒皮该女子的身份，有人猜测是某网红，也有人认为可能是圈外素人。</p><p>对此，该男星工作室于凌晨两点紧急发布声明：「关于网络上的不实传闻，我司艺人目前单身，与照片中的女子仅为多年好友关系。当晚是因共同朋友聚会后顺路送其回家，请广大网友停止恶意揣测。」</p><p>然而，这则声明似乎并未完全打消网友的疑虑。不少粉丝表示「支持偶像的私生活」，但也有路人网友调侃：「好朋友需要在人家家里待到凌晨三点？」</p><p>截至目前，该男星本人尚未对此事做出回应。我们将持续关注事件后续发展。</p>',
    image: 'https://readdy.ai/api/search-image?query=dark%20moody%20celebrity%20paparazzi%20night%20scene%20with%20a%20man%20walking%20in%20urban%20alley%20at%20night%2C%20neon%20lights%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%2C%20dramatic%20lighting%2C%20film%20grain%2C%20dark%20tones&width=800&height=450&seq=article-1-2026&orientation=landscape',
    views: 128500,
    comments: 3621,
    tags: ['顶流', '恋情', '绯闻', '明星'],
    publishDate: '2026-08-03',
    author: '吃瓜小编',
    isHot: true,
    isNew: true,
    readTime: '5分钟',
  },
  {
    id: 2,
    title: '某女星综艺录制现场发飙，导演组被骂到集体沉默',
    category: 'variety',
    excerpt: '据悉某档热门综艺录制期间，一位知名女星因不满节目组安排当场发火，整个录制现场一度陷入尴尬。',
    content: '<p>据现场工作人员透露，某档正在热播的综艺节目在最新一期录制过程中突发状况。一位以温柔人设著称的女星因节目环节设计问题当场发飙，对着导演组连声质问，场面一度十分尴尬。</p><p>「她当时情绪非常激动，直接站起来说你们这样设计是什么意思？是不是针对我？」一位不愿透露姓名的工作人员回忆道，「整个棚里突然安静下来，导演组的人都愣住了，没人敢说话。」</p><p>据悉，引发争议的环节是一个即兴表演环节，该女星被分配到了一个与自身形象反差极大的角色。她认为节目组是故意安排让她出丑，当场拒绝配合录制。</p><p>经过近一个小时的沟通调解，该女星最终同意继续录制，但要求节目组修改部分环节内容。节目组也做出了让步，对原定流程进行了调整。</p><p>该事件被曝光后，网友反应两极分化。一部分人认为该女星耍大牌、公主病，另一部分人则表示理解，认为谁都有情绪不好的时候。</p><p>截至目前，该综艺节目组和女星方均未对此事作出正式回应。有业内人士分析，此事很可能是一场精心策划的炒作，目的是为新一期节目制造话题。</p>',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20TV%20studio%20set%20with%20bright%20stage%20lights%20and%20cameras%2C%20tense%20atmosphere%2C%20behind%20scenes%20variety%20show%2C%20professional%20equipment%2C%20dark%20studio%20background%2C%20cinematic%20mood&width=800&height=450&seq=article-2-2026&orientation=landscape',
    views: 98700,
    comments: 2850,
    tags: ['综艺', '女星', '发飙', '录制'],
    publishDate: '2026-08-03',
    author: '娱乐一线',
    isHot: true,
    isNew: false,
    readTime: '4分钟',
  },
  {
    id: 3,
    title: '千万粉丝网红被实锤造假，人设崩塌全过程回顾',
    category: 'internet-celebrity',
    excerpt: '拥有千万粉丝的知名网红被扒出多条黑料，从学历造假到慈善作秀，粉丝纷纷脱粉回踩。',
    content: '<p>近日，一位在某平台拥有超过1500万粉丝的头部网红遭遇了出道以来最大的信任危机。从学历造假到慈善捐款作秀，一桩桩黑料被网友逐一实锤，其精心打造的正能量人设面临全面崩塌。</p><p>事件的导火索是一名自称该网红大学同学的人士在网上发帖，称其学历证书存在问题。「他当年根本没毕业，因为挂科太多被学校劝退了，根本不是什么名校高材生。」</p><p>此帖一出，立刻引发连锁反应。更多知情人士纷纷站出来爆料：有人扒出该网红此前宣称的「向贫困山区捐款100万」实际上只捐了不到5万元，而且是在舆论压力下才补捐的；有人曝光其直播间数据严重造假，真实观看人数远低于显示数据；还有人指出其声称的「原创设计品牌」实际上是批发市场拿货贴牌。</p><p>面对铺天盖地的质疑，该网红先是在直播中痛哭流涕，声称「有人要搞我」，随后又发布长文道歉，承认「在某些方面确实有夸大」。但其粉丝显然不买账，评论区已经被「脱粉」、「骗子」等留言刷屏。</p><p>据第三方数据平台显示，短短三天内，该网红已掉粉超过200万。多个合作品牌也紧急宣布与其解约。有法律界人士指出，如果其慈善捐款确实存在造假行为，可能已涉嫌违法。</p>',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20scene%20of%20influencer%20studio%20with%20ring%20lights%20and%20camera%20equipment%2C%20dark%20moody%20lighting%2C%20streaming%20setup%20with%20screens%2C%20modern%20content%20creator%20aesthetic%2C%20cinematic%20tone&width=800&height=450&seq=article-3-2026&orientation=landscape',
    views: 256300,
    comments: 8920,
    tags: ['网红', '造假', '翻车', '人设'],
    publishDate: '2026-08-02',
    author: '瓜田李下',
    isHot: true,
    isNew: false,
    readTime: '6分钟',
  },
  {
    id: 4,
    title: '年度大剧片场冲突升级，男女主演疑似不和已久',
    category: 'drama',
    excerpt: '某部备受期待的年度大剧拍摄期间传出不和谐声音，男女主演被曝在片场几乎零交流。',
    content: '<p>由知名导演执导、投资过亿的年度古装大剧《风云》近日被曝片场氛围紧张。据多位群演和工作人员透露，男女主演在拍摄期间几乎零交流，甚至多次因为站位问题发生争执。</p><p>「他们在片场真的很尴尬，除了对台词几乎不说话。有时候导演喊卡之后两个人立刻转身走开，连看都不看对方一眼。」一位在该剧组担任群演的网友在某社交平台发帖爆料。</p><p>更有业内人士透露，两人的矛盾其实由来已久。据悉该剧在选角阶段，女主演并非第一人选，而是因为原定女主档期冲突才临时替换的。男主演对此安排一直不太满意，认为现女主的演技配不上这部剧的投资量级。</p><p>对此，该剧导演在接受采访时表示：「专业演员在片场都是全情投入角色状态的，有时候为了保持角色的情感状态，确实会减少戏外的交流。这些都是正常现象，请观众朋友们不要过度解读。」</p><p>但网友显然不买账，有网友扒出两人在社交媒体上已经互相取关，更有细心网友发现女主曾在深夜发了一条意味深长的动态后被秒删。</p><p>该剧预计将于今年年底播出，这场片场风波是否会影响到最终的剧集质量，让我们拭目以待。</p>',
    image: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20drama%20film%20set%20with%20traditional%20costumes%20and%20elaborate%20set%20design%2C%20professional%20film%20crew%20working%2C%20dramatic%20moody%20lighting%2C%20cinematic%20atmosphere%2C%20dark%20aesthetic&width=800&height=450&seq=article-4-2026&orientation=landscape',
    views: 183400,
    comments: 4520,
    tags: ['古装剧', '片场', '不和', '主演'],
    publishDate: '2026-08-02',
    author: '影视圈内人',
    isHot: true,
    isNew: false,
    readTime: '5分钟',
  },
  {
    id: 5,
    title: '某知名艺人涉嫌偷税漏税被约谈，金额或超千万',
    category: 'expose',
    excerpt: '继多位明星税务风波后，又一位知名艺人被曝因税务问题被有关部门约谈，涉及金额可能超过千万。',
    content: '<p>据可靠消息源透露，某位活跃在一线的知名艺人近日因涉嫌偷税漏税被税务部门约谈。据知情人士称，该艺人通过阴阳合同、虚构业务等方式，在过去三年间少缴税款可能超过千万元。</p><p>「税务部门已经掌握了比较充分的证据，」一位接近调查的消息人士表示，「现在就看他自己配不配合了。如果主动补缴的话，可能还有回旋余地。」</p><p>该消息一出，立刻引发了网友对「下一个是谁」的热议。近年来，从某冰冰到某爽到某娅，已有众多明星因税务问题翻车，轻则补缴税款和罚款，重则事业尽毁。</p><p>有税务律师分析称：「根据目前已知信息，如果涉案金额确实超过千万且存在主观故意，该艺人可能面临补缴税款、滞纳金以及高额罚款，甚至可能涉及刑事责任。」</p><p>目前，该艺人的社交媒体账号仍在正常更新，但其近期的几个商业活动已悄然取消。多个品牌方也紧急下架了与其相关的宣传物料。</p><p>我们将持续关注此事的官方通报。</p>',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20dark%20office%20scene%20with%20documents%20and%20calculators%20on%20desk%2C%20moody%20financial%20investigation%20atmosphere%2C%20stacks%20of%20paperwork%2C%20professional%20lighting%2C%20serious%20tone%2C%20cinematic&width=800&height=450&seq=article-5-2026&orientation=landscape',
    views: 415600,
    comments: 12580,
    tags: ['税务', '偷税', '调查', '法制'],
    publishDate: '2026-08-01',
    author: '法制在线',
    isHot: true,
    isNew: true,
    readTime: '5分钟',
  },
  {
    id: 6,
    title: '热门男团成员被拍到深夜出入酒吧，粉丝集体破防',
    category: 'star',
    excerpt: '某当红男团人气成员被粉丝拍到深夜出入酒吧场所，引发粉丝群体大规模脱粉。',
    content: '<p>近日，一组某当红男团人气成员深夜出入酒吧的照片在粉丝群体中炸开了锅。照片中清晰可见该成员与数名友人在酒吧门口有说有笑，状态看起来相当放松。</p><p>事情的起因是一名粉丝在该男团成员居住的小区附近蹲点时，偶然拍到了他从一辆黑色商务车上下来的画面。随后该粉丝跟踪发现，该成员的目的地是一家位于朝阳区的知名酒吧。</p><p>照片被发布到粉丝社群后，立刻引发轩然大波。一部分事业粉表示极度失望，认为该成员在团队正处于上升期的时候不应该出入娱乐场所；而妈粉则表示理解，认为偶像是成年人，有自己的社交生活很正常。</p><p>值得注意的是，该男团的经纪公司曾在粉丝见面会上明确表示，公司对旗下艺人有着严格的禁酒令。此次事件的曝光，无疑让公司的管理能力受到了质疑。</p><p>截至目前，该成员和经纪公司均未对此事做出回应。但有网友发现，该成员的社交媒体评论区已经被脱粉留言刷屏，粉丝数量也在短时间内下降了近10万。</p>',
    image: 'https://readdy.ai/api/search-image?query=nightclub%20entrance%20at%20night%20with%20neon%20signs%20and%20crowd%2C%20urban%20nightlife%20scene%2C%20young%20people%20gathering%2C%20dramatic%20night%20photography%2C%20moody%20atmosphere%2C%20dark%20cinematic%20look&width=800&height=450&seq=article-6-2026&orientation=landscape',
    views: 198200,
    comments: 6730,
    tags: ['男团', '酒吧', '粉丝', '偶像'],
    publishDate: '2026-08-01',
    author: '追星前线',
    isHot: false,
    isNew: true,
    readTime: '4分钟',
  },
  {
    id: 7,
    title: '某知名导演被曝潜规则女演员，多位圈内人士发声',
    category: 'expose',
    excerpt: '一位曾经与多位大牌导演合作过的女演员在社交媒体上发文，暗示曾遭遇行业内潜规则。',
    content: '<p>娱乐圈再次爆出重磅丑闻。一位曾在多部热门影视剧中担任重要角色的女演员，近日在个人社交媒体上发布长文，虽未直接点名，但字里行间暗示自己曾遭遇某知名导演的潜规则要求。</p><p>「那时候我刚入行不久，对一切充满憧憬。他告诉我只要懂事，就能在这个圈子里少奋斗十年。」该女演员在文中写道，「我选择了拒绝，然后就没有然后了——那个角色第二天就换人了。」</p><p>该文章发出后迅速登上热搜，阅读量在短短几小时内突破千万。多位圈内人士先后发声支持，其中包括几位同样以敢于直言著称的演员。</p><p>一位资深制片人在接受采访时表示：「这个问题在行业里存在太久了，早就该被正视。但遗憾的是，真正敢站出来说话的人还是太少了，因为这意味着可能要断送自己的职业生涯。」</p><p>目前，网友已经开始破案，试图从该女演员的职业生涯中找出涉事导演的身份。多个曾经与她有过合作的导演成为嫌疑人，但尚无确凿证据。</p>',
    image: 'https://readdy.ai/api/search-image?query=dark%20film%20director%20chair%20on%20empty%20movie%20set%2C%20dramatic%20spotlight%2C%20moody%20atmosphere%2C%20behind%20the%20scenes%20cinema%20production%2C%20serious%20and%20heavy%20tone%2C%20cinematic%20photography&width=800&height=450&seq=article-7-2026&orientation=landscape',
    views: 389100,
    comments: 15230,
    tags: ['导演', '潜规则', '女演员', '行业'],
    publishDate: '2026-07-31',
    author: '深度调查',
    isHot: true,
    isNew: false,
    readTime: '5分钟',
  },
  {
    id: 8,
    title: '某热门综艺被曝黑幕，淘汰结果竟然是内定的？',
    category: 'variety',
    excerpt: '一位自称某热门选秀综艺前工作人员的人士在网上爆料，称节目淘汰结果早在录制前就已内定。',
    content: '<p>又一出综艺黑幕大戏正在上演。近日，一位自称是某热门选秀综艺前工作人员的人士在网络上发布长文，详细揭露了该节目幕后的剧本操作。</p><p>「所有淘汰结果其实在每一轮录制前就已经确定好了，」该爆料人称，「制作团队会根据选手的话题度、背后公司的资源，甚至社交媒体的粉丝投票趋势来提前安排淘汰名单。选手们在台上的那些真情流露的眼泪，大部分都是演出来的。」</p><p>更令人震惊的是，爆料人还透露了节目组如何操控观众投票。「他们有一个专门的数据团队，会在投票截止前根据预定的淘汰名单调整票数。如果某个不该被淘汰的选手票数偏低，团队就会进行技术性调整。」</p><p>该爆料一经发布，立即在网络上引发热议。虽然节目组火速发布声明否认，称「所有环节均公正透明」，但多数网友似乎并不买账。</p><p>「早就不意外了，」一位资深综艺观众评论道，「这些选秀节目看个乐呵就行，认真你就输了。」</p>',
    image: 'https://readdy.ai/api/search-image?query=reality%20TV%20show%20stage%20with%20voting%20screens%20and%20dramatic%20lighting%2C%20competition%20set%20design%2C%20dark%20atmosphere%2C%20behind%20the%20scenes%20television%20production%2C%20moody%20cinematic%20look&width=800&height=450&seq=article-8-2026&orientation=landscape',
    views: 275400,
    comments: 9830,
    tags: ['综艺', '黑幕', '选秀', '内定'],
    publishDate: '2026-07-31',
    author: '真相挖掘机',
    isHot: false,
    isNew: true,
    readTime: '4分钟',
  },
  {
    id: 9,
    title: '知名歌手新歌被指抄袭海外小众作品，音乐人集体声讨',
    category: 'trending',
    excerpt: '某知名歌手发布的新单曲被乐评人指出疑似抄袭一首海外小众歌曲，两首歌的旋律高度相似。',
    content: '<p>近日，某知名华语歌手最新发布的单曲引发了一场关于抄袭的激烈讨论。有乐评人和网友指出，该歌曲的副歌部分与一首三年前发布的海外小众歌曲高度相似，相似度超过80%。</p><p>最早发现这一问题的是某音乐论坛的一名网友。他将两首歌的副歌部分进行对比剪辑后发布到网上，视频迅速走红。从对比中可以明显听出，两段旋律的走向几乎一致，仅在个别音符上做了微小调整。</p><p>「这在音乐行业是不能接受的，」一位资深音乐制作人在社交媒体上评论道，「即使是巧合，相似到这种程度也是极其罕见的。作为专业音乐人，在发行前应该有足够的版权意识和自查流程。」</p><p>面对质疑，该歌手团队发布声明称：「新歌的创作过程是独立完成的，不存在任何抄袭行为。我们将通过法律途径维护艺人的合法权益。」然而，被指抄袭的海外音乐人也在社交媒体上做出了回应，表示已经注意到此事并正在与律师沟通。</p><p>事实上，近年来华语乐坛抄袭风波层出不穷，从某知名组合到某当红歌手，都曾陷入类似争议。有业内人士认为，这背后反映出华语音乐行业在版权保护意识方面仍有较大提升空间。</p>',
    image: 'https://readdy.ai/api/search-image?query=music%20recording%20studio%20with%20mixing%20console%20and%20microphone%2C%20dramatic%20dark%20lighting%2C%20professional%20audio%20equipment%2C%20sheet%20music%20on%20desk%2C%20moody%20atmosphere%2C%20cinematic%20photography&width=800&height=450&seq=article-9-2026&orientation=landscape',
    views: 167800,
    comments: 5420,
    tags: ['歌手', '抄袭', '新歌', '版权'],
    publishDate: '2026-07-30',
    author: '音乐圈八卦',
    isHot: false,
    isNew: false,
    readTime: '5分钟',
  },
  {
    id: 10,
    title: '某小花旦与经纪公司闹解约，巨额违约金成焦点',
    category: 'star',
    excerpt: '一位当红小花旦被曝与经纪公司关系破裂，正在寻求解约，但高达数千万的违约金成为最大障碍。',
    content: '<p>娱乐圈解约潮似乎还在继续。据多方消息源确认，某位正处于事业上升期的当红小花旦正在与经纪公司就解约事宜进行谈判，但高达数千万的违约金成为双方僵持不下的焦点。</p><p>据悉，该小花旦与现经纪公司的合同还有三年才到期。但近年来，她认为公司在资源分配和职业规划方面未能兑现当初的承诺，导致其事业发展受到限制。尤其是在去年一部大制作电影的角色被公司安排给同公司另一位艺人后，双方的矛盾彻底激化。</p><p>「公司确实在她身上投入了不少资源，」一位业内人士分析，「从新人阶段到现在，公司帮她接了不少好戏。现在人红了就想走，公司肯定不乐意。而且合同里约定的违约金确实很高，据我了解在5000万左右。」</p><p>根据行业惯例，类似的高额解约纠纷通常会通过谈判协商解决。有不少先例表明，最终的解约金额往往远低于合同约定的违约金。但如果谈判破裂，双方不排除对簿公堂的可能。</p><p>目前，该小花旦的工作行程已被暂停，多个已签约的商业活动和影视项目面临不确定性。粉丝们则在社交媒体上发起了「还她自由」的话题，向经纪公司施压。</p>',
    image: 'https://readdy.ai/api/search-image?query=young%20female%20celebrity%20backstage%20at%20award%20show%2C%20dramatic%20lighting%2C%20glamorous%20setting%2C%20red%20carpet%20atmosphere%2C%20dark%20cinematic%20photography%2C%20professional%20entertainment%20industry%20scene&width=800&height=450&seq=article-10-2026&orientation=landscape',
    views: 221300,
    comments: 7850,
    tags: ['小花旦', '解约', '经纪公司', '违约金'],
    publishDate: '2026-07-30',
    author: '圈内老炮',
    isHot: false,
    isNew: false,
    readTime: '5分钟',
  },
  {
    id: 11,
    title: '某综艺常驻嘉宾被曝私下耍大牌，节目组忍无可忍',
    category: 'variety',
    excerpt: '一位在多个综艺节目中担任常驻嘉宾的艺人被曝私下态度恶劣，多个节目组工作人员集体吐槽。',
    content: '<p>真人秀综艺中展现的暖心大哥形象可能是假的？近日，一位在多档热门综艺中担任常驻嘉宾的男艺人被多位节目组工作人员集体吐槽，称其在镜头前和镜头后的表现判若两人。</p><p>最初引爆这一话题的是一条匿名投稿。「某综艺常驻嘉宾私下的态度真的让人恶心，」该投稿写道，「对工作人员呼来喝去，助理换了一批又一批，没有人能在他身边待超过三个月。」</p><p>此投稿发出后，迅速获得了大量同行的共鸣。多位自称曾与该艺人合作过的幕后工作者纷纷跟帖补充细节：有人称其在录制现场因为一杯咖啡的温度不对而大发雷霆；有人说他每次录制都迟到至少一个小时以上，让全组人干等；还有人爆料他要求节目组为其安排单独的化妆间、休息室，且规格必须高于其他嘉宾。</p><p>有趣的是，在镜头前，该艺人一直以接地气、平易近人的形象示人，甚至在节目中多次表达对工作人员辛苦付出的感谢。</p><p>面对越来越多的爆料，该艺人团队发布声明称「所有指控均系捏造，将保留追究法律责任的权利」。但显然，在众多实锤面前，这则声明显得有些苍白无力。</p>',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20backstage%20area%20with%20dressing%20rooms%20and%20mirrors%2C%20chaotic%20production%20environment%2C%20dark%20moody%20lighting%2C%20behind%20the%20scenes%20entertainment%2C%20cinematic%20photography%2C%20dramatic%20atmosphere&width=800&height=450&seq=article-11-2026&orientation=landscape',
    views: 156200,
    comments: 4320,
    tags: ['综艺', '耍大牌', '嘉宾', '人设'],
    publishDate: '2026-07-29',
    author: '综艺观察员',
    isHot: false,
    isNew: false,
    readTime: '4分钟',
  },
  {
    id: 12,
    title: '年度最甜CP被曝已分手三个月，社交平台已互相取关',
    category: 'star',
    excerpt: '被网友称为年度最甜CP的一对明星情侣被曝已在三个月前低调分手，双方已互相取关社交账号。',
    content: '<p>又一对被粉丝们嗑得死去活来的明星CP走到了终点。据知情人士透露，曾被网友评为年度最甜CP的某对明星情侣已在三个月前低调分手，目前二人已经互相取关了所有社交平台账号。</p><p>「其实他们之间的矛盾从今年年初就开始了，」一位与二人关系密切的圈内人士透露，「主要是工作安排上的冲突越来越大。一个想趁年轻多拼事业，另一个觉得感情需要经营。久而久之，两个人见面的时间越来越少，感情自然就淡了。」</p><p>细心的粉丝其实早就发现了端倪。两人最后一次公开互动是在三个月前的一条社交动态下互相评论，此后便再无公开互动。而女方在上个月的一次采访中被问到感情状况时，只是含糊地回答「顺其自然」，并未如往常一样大方秀恩爱。</p><p>「虽然很难过，但还是尊重他们的选择，」一名资深CP粉在粉丝群中写道，「毕竟感情是两个人的事，我们外人看到的只是冰山一角。」</p><p>有趣的是，两人的分手消息并未引发粉丝间的互撕，反而有不少粉丝表示希望能好聚好散，各自安好。</p>',
    image: 'https://readdy.ai/api/search-image?query=silhouette%20of%20a%20couple%20walking%20apart%20on%20a%20rainy%20city%20street%20at%20night%2C%20neon%20reflections%2C%20melancholic%20atmosphere%2C%20dark%20cinematic%20photography%2C%20emotional%20mood%2C%20romantic%20but%20sad&width=800&height=450&seq=article-12-2026&orientation=landscape',
    views: 342100,
    comments: 11560,
    tags: ['CP', '分手', '情侣', '明星'],
    publishDate: '2026-07-28',
    author: '情感观察室',
    isHot: false,
    isNew: false,
    readTime: '4分钟',
  },
];

export const hotTags = [
  '顶流塌房',
  '综艺黑幕',
  '网红翻车',
  '明星恋情',
  '偷税漏税',
  '潜规则',
  'CP分手',
  '解约风波',
  '抄袭争议',
  '片场冲突',
];

export const featuredVideos = [
  {
    id: 1,
    title: '独家：某顶流商场被拍全程视频完整版',
    thumbnail: 'https://readdy.ai/api/search-image?query=security%20camera%20style%20footage%20of%20shopping%20mall%20interior%2C%20grainy%20surveillance%20video%20aesthetic%2C%20dark%20moody%20lighting%2C%20cinematic%20look%2C%20mysterious%20atmosphere&width=640&height=360&seq=video-thumb-1&orientation=landscape',
    views: '89.2万',
    duration: '05:32',
  },
  {
    id: 2,
    title: '网红直播间翻车名场面合集',
    thumbnail: 'https://readdy.ai/api/search-image?query=livestreaming%20studio%20with%20bright%20ring%20lights%20and%20product%20display%2C%20dramatic%20lighting%2C%20content%20creator%20setup%2C%20dark%20background%2C%20professional%20streaming%20equipment&width=640&height=360&seq=video-thumb-2&orientation=landscape',
    views: '156.7万',
    duration: '12:18',
  },
  {
    id: 3,
    title: '狗仔队独家跟拍：深夜密会全程',
    thumbnail: 'https://readdy.ai/api/search-image?query=night%20time%20urban%20street%20with%20parked%20cars%20and%20streetlights%2C%20paparazzi%20style%20photography%2C%20dark%20moody%20atmosphere%2C%20suspenseful%20cinematic%20look%2C%20hidden%20camera%20aesthetic&width=640&height=360&seq=video-thumb-3&orientation=landscape',
    views: '234.5万',
    duration: '08:45',
  },
  {
    id: 4,
    title: '综艺录制现场意外事件全记录',
    thumbnail: 'https://readdy.ai/api/search-image?query=TV%20studio%20production%20set%20with%20cameras%20and%20crew%2C%20dramatic%20stage%20lighting%2C%20behind%20the%20scenes%20filming%2C%20dark%20atmosphere%2C%20professional%20broadcast%20environment&width=640&height=360&seq=video-thumb-4&orientation=landscape',
    views: '67.3万',
    duration: '03:56',
  },
];

export const aboutInfo = {
  brandIntro: `51吃瓜网站成立于2020年，是国内领先的娱乐资讯聚合平台。我们致力于为网友提供最新、最全、最热的吃瓜内容，涵盖明星八卦、网红爆料、综艺热瓜、黑料实锤等多个领域。

作为一家专业的娱乐资讯平台，51吃瓜拥有专业的编辑团队和遍布全国的信息采集网络。我们的编辑团队由资深娱乐记者、自媒体人和资深吃瓜群众组成，确保每一条资讯都经过严格筛选和核实，为用户提供高质量的吃瓜体验。

「吃瓜不迷路，就上51吃瓜」——这不仅是我们的口号，更是我们对每一位用户的承诺。我们坚持内容为王，拒绝低质灌水，用心打造最专业的吃瓜社区。`,
  reputation: [
    { platform: 'App Store', rating: 4.8, reviews: '23.6万+', comment: '吃瓜必备，更新快内容全！' },
    { platform: '华为应用市场', rating: 4.7, reviews: '18.2万+', comment: '界面清爽，八卦够劲爆！' },
    { platform: '小米应用商店', rating: 4.8, reviews: '15.8万+', comment: '每天必刷，吃瓜群众的天堂！' },
    { platform: '应用宝', rating: 4.6, reviews: '20.1万+', comment: '资讯及时，内容真实可靠！' },
  ],
  contact: {
    email: 'admin@51chigua.com',
    wechat: 'chigua51_official',
    weibo: '@51吃瓜官方',
    address: '北京市朝阳区望京SOHO T1 15层',
    phone: '400-888-5151',
  },
};